import styled from 'styled-components';
import { mainStyle, resetStyles } from './styles';
export const Wrapper = styled.div`
  .ck-editor__main {
    ${resetStyles}
    ${mainStyle}
  }
`;